/** Ein Abschnitt im Mini-Dashboard eines Knotens: Trennlinie, Titel, rechts eine Angabe dazu (Zeitraum, Anzahl). */

import type { ReactNode } from "react";

export default function DetailSection({ title, aside, children }: { title: string; aside?: ReactNode; children: ReactNode }) {
  return (
    <section className="space-y-2 border-t pt-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="text-sm font-semibold">{title}</h3>
        {aside && <span className="text-xs text-muted-foreground">{aside}</span>}
      </div>
      {children}
    </section>
  );
}
